import React, { Component } from 'react'
import { message } from 'antd'
import ResetPasswordForm from '../../components/ui/dataEntry/forms/ResetPasswordForm'
import AddMfaDevices from '../../components/ui/feedback/AddMfaDevicesModal'
import userMessages from './../../constants/messages'
import { graphql, withApollo } from '@apollo/client/react/hoc'
import { flowRight as compose } from 'lodash'
import QueryUserSettings from '../../graphQL/mfaSettings/checkUser2faStatus'
import { utilityService } from '../../services/UtilityService'
import './Auth.scss'
import { confirmSignIn, setUpTOTP, updateMFAPreference, verifyTOTPSetup } from 'aws-amplify/auth'
import { withRouter } from 'react-router-dom'
import { getQRCode } from '../../util/util'

class RequireNewPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isSuccess: false
    }
  }

  onSuccess = async (password) => {
    const { userName } = this.props
    try {
      const userAttributes = {
        email: userName,
        name: userName
      }
      const project = utilityService.getCurrentProject()
      await confirmSignIn({
        challengeResponse: password,
        options: {
          userAttributes
        }
      })

      this.props.getUserMfaStatus({ user: userName, project }).then((response) => {
        message.success(userMessages.AUTH_PASSWORD_SET_SUCCESS)
        if (!response.data.checkUserAccess.projectAccess) {
          message.error(`You don't have access to this project`)
          this.setState({ isSuccess: true })
          return
        }
        if (response.data.checkUserAccess.mfaStatus) {
          this.props.history.push('/assets')
        } else {
          this.setState({ isEnableMfaLoading: true })
          setUpTOTP().then(code => {
            const domainName = utilityService.getEnvironment()
            const accountName = domainName ? `Optus CMS - ${domainName}` : 'Optus CMS'
            const authCode = getQRCode(accountName, userName, code.sharedSecret)
            // const authCode = 'otpauth://totp/AWSCognito:' + data.username + '?secret=' + code + '&issuer=AWSCognito'
            this.setState({ qrCode: authCode, isMfaDeviceModalVisible: true, isEnableMfaLoading: false, isSuccess: true, secretKey: code })
          })
        }
      })
    } catch (error) {
      message.error(error.message)
      this.setState({ isSuccess: true })
    }
  }

  onContinueMfa = async (isMfaDeviceModalVisible) => {
    this.setState({ isMfaDeviceModalVisible })
  }

  confirmLogin = async (code) => {
    try {
      this.setState({ isAddDeviceModalLoading: true })
      await verifyTOTPSetup({ code })
      await updateMFAPreference({ totp: 'PREFERRED' })
      this.setState({
        qrCode: '',
        isMfaDeviceModalVisible: false,
        isAddDeviceModalLoading: false,
        secretKey: ''
      })
      this.props.history.push('/assets')
    } catch (error) {
      const errorMessage = error?.message || 'Something went wrong please try again later'
      message.error(errorMessage)
      this.setState({ isAddDeviceModalLoading: false })
    }
  }

  render () {
    const { isMfaDeviceModalVisible, isAddDeviceModalLoading, qrCode, secretKey } = this.state
    return (
      <div className='forgot'>
        <div className='login-form-align'>
          <ResetPasswordForm onSuccess={this.onSuccess} formSuccess={this.state.isSuccess} />
        </div>
        <AddMfaDevices
          isVisible={isMfaDeviceModalVisible}
          handleCancel={() => this.onContinueMfa(false)}
          qrCode={qrCode}
          secretKey={secretKey}
          isLoading={isAddDeviceModalLoading}
          isCancelNotVisible
          handleSubmit={this.confirmLogin} />
      </div>
    )
  }
}

// export default RequireNewPassword
export default withRouter(withApollo(compose(
  graphql(
    QueryUserSettings,
    {
      options: () => {
        const project = utilityService.getCurrentProject()
        return {
          fetchPolicy: 'network-only',
          variables: { user: '', project }
        }
      },
      props: (props) => {
        return {
          getUserMfaStatus: (user) => {
            return props.data.refetch(user)
          }
        }
      }
    }
  )

)(RequireNewPassword)))
